import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials disabled to work with CORS wildcard
  withCredentials: false,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local user data on 401
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
};

// Services APIs
export const servicesAPI = {
  getAll: () => api.get('/services'),
  getById: (id) => api.get(`/services/${id}`),
};

// Service Requests APIs
export const serviceRequestsAPI = {
  create: (data) => api.post('/service-requests', data),
  getAll: () => api.get('/service-requests'),
  getById: (id) => api.get(`/service-requests/${id}`),
  delete: (id) => api.delete(`/service-requests/${id}`),
};

// Documents APIs
export const documentsAPI = {
  upload: (data) => api.post('/documents/upload', data),
  getAll: (serviceRequestId) => {
    const params = serviceRequestId ? `?service_request_id=${serviceRequestId}` : '';
    return api.get(`/documents${params}`);
  },
  delete: (id) => api.delete(`/documents/${id}`),
};

// Payments APIs
export const paymentsAPI = {
  create: (data) => api.post('/payments', data),
  getAll: () => api.get('/payments'),
  getQR: (serviceRequestId) => api.get(`/payments/qr?service_request_id=${serviceRequestId}`),
};

// Tasks APIs
export const tasksAPI = {
  getAll: () => api.get('/tasks'),
};

export default api;
